import { Component, Inject, OnInit } from "@angular/core";
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import {
  ContentActivityEntry,
  ContentActivityService,
  ContentActivityType,
} from "src/app/Services/content-activity.service";

export interface ContentActivityDialogData {
  contentType: ContentActivityType;
  contentId: string;
  title?: string;
}

type ActivityFilter = "all" | "Approval" | "Edit" | "Access";

@Component({
  selector: "app-content-activity-panel",
  templateUrl: "./content-activity-panel.component.html",
  styleUrls: ["./content-activity-panel.component.scss"],
})
export class ContentActivityPanelComponent implements OnInit {
  loading = false;
  error: string | null = null;
  entries: ContentActivityEntry[] = [];
  filter: ActivityFilter = "all";

  readonly filters: { id: ActivityFilter; label: string; icon: string }[] = [
    { id: "all", label: "All", icon: "history" },
    { id: "Approval", label: "Approvals", icon: "fact_check" },
    { id: "Edit", label: "Content", icon: "edit_note" },
    { id: "Access", label: "Access", icon: "lock" },
  ];

  constructor(
    private dialogRef: MatDialogRef<ContentActivityPanelComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ContentActivityDialogData,
    private activityService: ContentActivityService
  ) {}

  static open(dialog: MatDialog, data: ContentActivityDialogData) {
    return dialog.open(ContentActivityPanelComponent, {
      data,
      width: "min(760px, 96vw)",
      maxWidth: "96vw",
      panelClass: "content-activity-dialog",
      autoFocus: false,
    });
  }

  get kindLabel(): string {
    return this.data?.contentType === "guidePack" ? "Guide pack" : "Guide";
  }

  get filteredEntries(): ContentActivityEntry[] {
    if (this.filter === "all") return this.entries;
    return this.entries.filter((e) => e.category === this.filter);
  }

  countFor(filter: ActivityFilter): number {
    if (filter === "all") return this.entries.length;
    return this.entries.filter((e) => e.category === filter).length;
  }

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    if (!this.data?.contentId) {
      this.error = "Save this content first to start tracking its activity.";
      return;
    }
    this.loading = true;
    this.error = null;
    this.activityService.list(this.data.contentType, this.data.contentId).subscribe({
      next: (rows) => {
        this.entries = rows || [];
        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
        this.error =
          err?.status === 403 || err?.status === 401
            ? "You don't have permission to view this activity."
            : err?.error?.message || "Could not load activity. Please try again.";
      },
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
